import { Search } from '@mui/icons-material';
import { Button, IconButton, TextField } from '@mui/material';
import React, { createRef, useContext, useEffect, useRef, useState } from 'react'
import { Table } from 'react-bootstrap';
import { AuthContext } from '../../context/AuthContext';
import { ReporteFallas } from '../../helpers/AsuntosHelper';

export const ReporteFallasPage = () => {
    const {usuario} = useContext(AuthContext);
    const [datosReporte, setDatosReporte] = useState();
    const [filtroInicio, setFiltroInicio] = useState();
    const [filtroFin, setFiltroFin] = useState()
    const tabla = useRef();

    useEffect(() => {
        obtenerDatos();
    }, [])

    const obtenerDatos = () => {
        console.log('datos de usuario', usuario)
        const data = new FormData();
        data.append('tipoUsuario', usuario.IdTipoUsuario);
        data.append('inicio', filtroInicio);
        data.append('fin', filtroFin);
        ReporteFallas(usuario.IdUsuario, data).then(response => {
            console.log('datos reporte', response);
            setDatosReporte(response);
        })
    }

    const copiar = () => {
    const tablaExportar = document.getElementById('tablaReportes'); 

    navigator.clipboard.writeText(tabla)
    console.log(tablaExportar)
       
    }
    

  return (
    <div
    style={{
      display:'flex',
      flexDirection:'row',
      flex:1,
      backgroundColor:'transparent',
      marginBottom:'20',
      padding:20
  //    height:'100%'
    }}
  >
  <div
  style={{
      display:'flex',
      flexDirection:'column',
      flex:1,
        color:'black',
        marginTop:10,
        marginLeft:40,
        marginRight:20,
    //    height:'100%'
    }}    
  >
    <div
      style={{
        display:'flex',
        flexDirection:'row',
        justifyContent:'space-between',
  //      maxWidth:700,
      }}
    >

      <span
          style={{
            fontSize:40,
            fontWeight:'bold'
          }}
          >
          Reporte de Fallas
      </span>
      <span
        style={{
          display:'flex',
          flexDirection:'row',
          alignItems:'center',
          marginRight:40
        }}
      >
                <TextField
            onChange={(e) => setFiltroInicio(e.target.value)}
            value={filtroInicio}
            InputLabelProps={{shrink:true, fontSize:10 }}
            margin="dense"
            label="Desde"
            type="date"
            fullWidth
            variant="filled"
            style={{maxWidth:150,
              backgroundColor:'white',
              borderRadius:10,
              fontSize:12
            }}
            />
        <TextField
          onChange={(e) => setFiltroFin(e.target.value)}
          value={filtroFin}
          InputLabelProps={{shrink:true}}
          margin="dense"
          label="Hasta"
          type="date"
          fullWidth
          variant="filled"
            style={{maxWidth:150,
              backgroundColor:'white',
              borderRadius:10,
              marginLeft:10
            }}
          />
                    <IconButton
            onClick={() => {obtenerDatos()}}
          >
            <Search 
              style={{
                color:'black',
                marginLeft:10,
                fontSize:30
              }} 
            />
          </IconButton>
      </span>
    </div>
    <div
        style={{
            display:'flex',
            flexDirection:'column',
            marginTop:50
        }}
    >
        <Table id='tablaReportes' ref={tabla} hover striped={true} responsive>
            <thead>
              <tr style={{fontSize:11, backgroundColor:'black', color:'white'}}>
                <th>Reporta</th>
                <th>Descripción de la falla</th>
                <th>Instalación</th>
                <th>Fecha/Hora del Reporte</th>
                <th>Responsable</th>
                <th>Fecha/Hora Cierre</th>
                <th>Avance</th>
                <th>Tipo</th>
                <th>¿Cierre de carril?</th>
                <th>Capítulo</th>
              </tr>
            </thead>
            <tbody>
                {
                    datosReporte?.map(asunto =>(
                        <tr style={{fontSize:11}}>
                            <td style={{maxWidth:400,flex:20}}>{asunto?.reporta}</td>
                            <td style={{maxWidth:400,flex:20}}>{asunto?.descripcion}</td>
                            <td style={{maxWidth:400, flex:20}}>{asunto?.ruta}</td>
                            <td style={{wordWrap:false, flex:10}}>{asunto?.FechaSolicitud}</td>
                            <td>{asunto?.responsable}</td>
                            <td>{asunto?.fechaCierre}</td>
                            <td>{asunto?.PorcentajeAsunto}</td>
                            <td>{asunto?.tipoServicio}</td>
                            <td>{asunto?.cierreCarril}</td>
                            <td>{asunto?.capitulo}</td>
                        </tr>
                    ))
                }
            </tbody>
        </Table>
    </div>
</div>
</div>
  )
}
